import { createSlice } from '@reduxjs/toolkit';
import { addNewDocument, editDocument, editDocumentImage, getAllDocuments, getDocumentById } from './documentService';

const initialState = {
  allDocuments: {
    isDocumentsLoading: null,
    isDocumentsSuccess: null,
    documentsMessage: null,
    pageCount: 0,
    documents: [],
  },
  newDocument: {
    isDocumentCreating: null,
    isDocumentCreated: null,
    documentCreationMsg: null,
  },

  editedDocument: {
    isEditingDocument: null,
    isDocumentEdited: null,
    documentEditedMsg: null
  },

  document: {
    isDocumentLoading: null,
    isDocumentSuccess: null,
    documentMessage: null,
    document: null,
  },
};

const documentsSlice = createSlice({
  name: 'document',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // All documents
    builder
      .addCase(getAllDocuments.pending, (state) => {
        state.allDocuments = {
          ...initialState.allDocuments,
          isDocumentsLoading: true,
          documentsMessage: 'Loading',
        };
      })

      .addCase(getAllDocuments.rejected, (state, action) => {
        state.allDocuments = {
          ...initialState.allDocuments,
          isDocumentsLoading: false,
          isDocumentsSuccess: false,
          documentsMessage: action.payload || 'Error occurred while fetching documents',
        };
      })

      .addCase(getAllDocuments.fulfilled, (state, action) => {
        state.allDocuments = {
          ...initialState.allDocuments,
          isDocumentsLoading: false,
          isDocumentsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          documents: action.payload.data || [],
        };
      });

    //Document creating
    builder
      .addCase(addNewDocument.pending, (state) => {
        state.newDocument = {
          ...initialState.newDocument, 
          isDocumentCreating: true,
          documentCreationMsg: 'Loading',
        };
      })

      .addCase(addNewDocument.rejected, (state, action) => {
        state.newDocument = {
          ...initialState.newDocument,
          isDocumentCreating: false,
          isDocumentCreated: false,
          documentCreationMsg: action.payload || 'Error occurred while creating the document.',
        };
      })

      .addCase(addNewDocument.fulfilled, (state, action) => {
        state.newDocument = {
          ...initialState.newDocument,
          isDocumentCreating: false,
          isDocumentCreated: true,
          documentCreationMsg: action.payload || 'Successfully created the document.',
        };
      });

    //Document editing
    builder
      .addCase(editDocument.pending, (state) => {
        state.editedDocument = {
          ...initialState.editedDocument, 
          isEditingDocument: true,
          documentEditedMsg: 'Loading',
        };
      })

      .addCase(editDocument.rejected, (state, action) => {
        state.editedDocument = {
          ...initialState.editedDocument,
          isEditingDocument: false,
          isDocumentEdited: false,
          documentEditedMsg: action.payload || 'Error occurred while editing the document.',
        };
      })

      .addCase(editDocument.fulfilled, (state, action) => {
        state.editedDocument = {
          ...initialState.editedDocument,
          isEditingDocument: false,
          isDocumentEdited: true,
          documentEditedMsg: action.payload || 'Successfully edited the document.',
        };
      });

      //Document details
      builder
      .addCase(getDocumentById.pending, (state) => {
        state.document = {
          ...initialState.document, 
          isDocumentLoading: true,
          documentMessage: 'Loading',
        };
      })

      .addCase(getDocumentById.rejected, (state, action) => {
        state.document = {
          ...initialState.document,
          isDocumentLoading: false,
          isDocumentSuccess: false,
          documentMessage: action.payload || 'Error occurred while fetching document',
        };
      })

      .addCase(getDocumentById.fulfilled, (state, action) => {
        state.document = {
          ...initialState.document,
          isDocumentLoading: false,
          isDocumentSuccess: true,
          document: action.payload,
        };
      });
  },
});

export default documentsSlice.reducer;
